import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged-out
  const [centers, setCenters] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (user && user.id) {
      api.get("/centers").then((r) => setCenters(r.data)).catch(() => setCenters([]));
    }
  }, [user]);

  const login = async (employee_id, password) => {
    const { data } = await api.post("/auth/login", { employee_id, password });
    if (data?.token) localStorage.setItem("ac_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore logout errors
    }
    localStorage.removeItem("ac_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, centers, login, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
